import { Link } from "react-router-dom";

export const PublicFooter = () => (
  <footer data-testid="public-footer" className="mt-12 border-t border-slate-200 py-6 px-6 text-center text-xs text-slate-500 space-x-3">
    <span data-testid="public-footer-copyright">© 2026 SOLUTIONS PRIME — Tous droits réservés</span>
    <span aria-hidden="true">·</span>
    <Link data-testid="public-footer-privacy-link" to="/confidentialite" className="underline hover:text-slate-800">Politique de confidentialité</Link>
    <span aria-hidden="true">·</span>
    <Link data-testid="public-footer-legal-link" to="/mentions-legales" className="underline hover:text-slate-800">Mentions légales</Link>
  </footer>
);
